// Scrive nelle variabili CSS --glow-x e --glow-y la posizione del puntatore dentro l'elemento, per l'utility
// `glass-glow` (bordo che si illumina verso il mouse). Un solo aggiornamento per frame (requestAnimationFrame);
// su touch e senza puntatore non fa nulla.
export function useGlowBordo(elemento: Ref<HTMLElement | null>, attivo: Ref<boolean> | boolean = true) {
  let frame = 0;
  let ultimo: { x: number; y: number } | null = null;

  function aggiorna(): void {
    frame = 0;
    const el = elemento.value;
    if (!el || !ultimo) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--glow-x", `${ultimo.x - r.left}px`);
    el.style.setProperty("--glow-y", `${ultimo.y - r.top}px`);
  }

  function onPointerMove(evento: PointerEvent): void {
    if (evento.pointerType === "touch") return;
    ultimo = { x: evento.clientX, y: evento.clientY };
    if (!frame) frame = requestAnimationFrame(aggiorna);
  }

  onMounted(() => {
    if (unref(attivo)) elemento.value?.addEventListener("pointermove", onPointerMove, { passive: true });
  });

  onBeforeUnmount(() => {
    elemento.value?.removeEventListener("pointermove", onPointerMove);
    if (frame) cancelAnimationFrame(frame);
  });
}
